import { createFileRoute } from '@tanstack/react-router'
import { Dashboard } from '../../features/impacts/components/Dashboard.tsx'

export const Route = createFileRoute('/_app/impacts/')({
	component: Dashboard,
})
